import Swiper from "swiper/bundle";

const swiper = new Swiper(".vertical_photo_carousel", {
    direction: "vertical",
    slidesPerView: 3,
    spaceBetween: 16,
    loop: true,
    speed: 1200,
    autoplay: {
        delay: 1500,
        disableOnInteraction: false,
    },
    allowTouchMove: true,
    breakpoints: {
        300: {
            spaceBetween: 12,
        },
        768: {
            spaceBetween: 16,
        },
    }
});